import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Page } from "@models/page";
import { Sale } from "@models/sale";
import { PaginatorState } from "primeng/paginator";
import { catchError, of } from "rxjs";
import { environment } from "../../environments/environment";

export interface SalesFilters {
  seller_id?: number;
  // Busca pelo nome do evento (event_name no backend)
  event_name?: string;
  // Busca pelo nome do comprador (name no backend)
  name?: string;
  // Status do pagamento: paid | receivable | complimentary | refunded | cancelled | unpaid
  status?: string;
}

@Injectable({
  providedIn: "root",
})
export class SalesService {
  private readonly baseUrl = `${environment.API_BACKEND}/my_sales`;

  constructor(private http: HttpClient) {}

  getSales(pageEvent?: PaginatorState, filters: SalesFilters = {}) {
    const page = pageEvent?.page ?? 0;
    let params = new HttpParams()
      .set("page", page + 1)
      .set("per_page", pageEvent?.rows ?? 5);

    if (filters.seller_id !== undefined) {
      params = params.set("seller_id", filters.seller_id);
    }
    if (filters.event_name?.trim()) {
      params = params.set("event_name", filters.event_name.trim());
    }
    if (filters.name?.trim()) {
      params = params.set("name", filters.name.trim());
    }
    if (filters.status) {
      params = params.set("status", filters.status);
    }

    return this.http
      .get<Page<Sale>>(`${this.baseUrl}`, {
        params,
      })
      .pipe(
        catchError(() =>
          of({
            data: [],
            meta: {
              total_count: 0,
              total_pages: 0,
              current_page: 0,
              page_size: 10,
            },
          } as Page<Sale>),
        ),
      );
  }
}
